// What the store held before the board's canvas was ready (issue 1420). Pixi's start is asynchronous and, on a reload,
// can take well over a second; each of the board's store effects used to try once more after 120 ms and then give up,
// so a focus or an area already in the state on arrival was listed in Properties but never drawn until the next live
// change. Now an effect that finds no scene leaves its latest drawing here, and the board runs every one as it is ready.
export class LateScene<S> {
  private scene: S | null = null;
  private readonly waiting = new Map<string, (s: S) => void>();

  /** Draws now if the scene is up; otherwise keeps this (the latest for its key) for when it is. */
  run(key: string, apply: (s: S) => void): void {
    if (this.scene) { apply(this.scene); return; }
    this.waiting.set(key, apply);
  }

  /** The scene is up: everything that waited is drawn, in the order it first waited. */
  ready(scene: S): void {
    this.scene = scene;
    const waited = [...this.waiting.values()];
    this.waiting.clear();
    for (const apply of waited) apply(scene);
  }

  /** The scene is gone (the board unmounted); what follows waits for the next. */
  gone(): void { this.scene = null; }
}
